<template>
    <v-dialog
        v-model="show"
        persistent
        max-width="500px">
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.importEmployeeData') }}
                </span>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-form>
                    <v-container>
                        <v-row>
                            <div class="result-box locale-font">
                                <div class="result-title">
                                    {{ title }}
                                </div>
                                <v-container class="pb-0">
                                    <v-row
                                        class="result-row"
                                        v-for="(description, label, index) in content"
                                        :key="index">
                                        <v-col
                                            cols="9"
                                            class="result-label">
                                            {{ label }}
                                        </v-col>
                                        <v-col
                                            cols="3"
                                            class="result-value">
                                            {{ `: ${description}` }}
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </div>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions class="pb-6 pr-6">
                <v-spacer/>
                <v-btn
                    color="primary"
                    @click="closeModal()">
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.close') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'ImportEmployeeResultModal',

    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: Object,
            default: null
        }

    },

    data () {
        return {
            show: false
        }
    },

    methods: {
        showModal () {
            this.show = true
        },

        closeModal () {
            this.show = false
        }
    }
}
</script>

<style lang="scss" scoped>
.result-box {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    box-shadow: 0 5px 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: 15px !important;
    padding: 15px;
    background-color: lighten($color: #6c6c6c, $amount: 50);

    max-height: 220px;
    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 8px;
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #555;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #F5F5F5;
    }

    .result-title {
        margin-top: 5px;
        line-height: 1.29;
        font-size: 16px;
        color: #131410;
    }

    .result-row {
        padding-top: 3px;
        font-size: 14px;
        .result-label {
            padding: 0px;
            color: #6c6c6c;
        }
        .result-value {
            padding: 0px;
            color: #6c6c6c;
        }
    }
}
</style>
